import React, { useState } from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";
import { FormattedMessage } from "react-intl";
import { USERAXIOS } from "../../../../../api/userAxios";
import { openSnackbar } from "api/snackbar";
import { SnackbarProps } from "types/snackbar";
import { PopupTransition } from "components/@extended/Transitions";
import Avatar from "components/@extended/Avatar";
import { DeleteFilled } from "@ant-design/icons";

interface AlertCommentDeleteProps {
  open: boolean;
  handleClose: () => void;
  id: number;
  title: string;
  setResult: (data: any) => void;
  fetchData: () => void;
  setOpen: (open: boolean) => void;
}

const AlertCommentDelete = ({
  open,
  handleClose,
  id,
  title,
  setResult,
  fetchData,
  setOpen,
}: AlertCommentDeleteProps) => {
  const [isDeleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    try {
      setDeleting(true);
      await USERAXIOS.delete(`/blog_comments/${id}`);
      setResult((prevResults: any[]) =>
        prevResults.filter((item) => item.id !== id)
      );
      openSnackbar({
        open: true,
        message: "Comment deleted successfully",
        anchorOrigin: { vertical: "top", horizontal: "right" },
        variant: "alert",
        alert: {
          color: "success",
        },
      } as SnackbarProps);
      setOpen(false);
    } catch (error) {
      console.error("Error deleting comment:", error);
      openSnackbar({
        open: true,
        message: "Error deleting comment",
        anchorOrigin: { vertical: "top", horizontal: "right" },
        variant: "alert",
        alert: {
          color: "error",
        },
      } as SnackbarProps);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      keepMounted
      TransitionComponent={PopupTransition}
      maxWidth="xs"
      aria-labelledby="column-delete-title"
      aria-describedby="column-delete-description"
    >
      <DialogContent sx={{ mt: 2, my: 1 }}>
        <Stack alignItems="center" spacing={3.5}>
          <Avatar
            color="error"
            sx={{ width: 72, height: 72, fontSize: "1.75rem" }}
          >
            <DeleteFilled />
          </Avatar>
          <Stack spacing={2}>
            <Typography variant="h4" align="center">
              <FormattedMessage id="Are you sure you want to delete" />
            </Typography>
            <Typography align="center">
              <FormattedMessage id="By deleting" />
              <Typography variant="subtitle1" component="span">
                {" "}
                "{title}"{" "}
              </Typography>
              <FormattedMessage id="all data assigned to that category will also be deleted" />
            </Typography>
          </Stack>

          <Stack direction="row" spacing={2} sx={{ width: 1 }}>
            <Button
              fullWidth
              onClick={handleClose}
              color="secondary"
              variant="outlined"
            >
              <FormattedMessage id="Cancel" />
            </Button>
            <Button
              disabled={isDeleting}
              fullWidth
              color="error"
              variant="contained"
              onClick={handleDelete}
              autoFocus
            >
              <FormattedMessage id="Delete" />
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default AlertCommentDelete;
